// extracted by mini-css-extract-plugin
export default {"propertyDetails":"XEHLediSwgxjECAKpx_7","fullWidth":"KcJLUfkMP9aurlMW05vB","signupLink":"l9bYn0nqM5aApr_pBP1W"};